
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","viewBox":"0 0 18 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M10.999 2.305C13.867 3.317 16 6 16 9v2.99c0 .37.187.997.383 1.299l1.454 2.223a1 1 0 0 1 .163.547V17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.941a1 1 0 0 1 .163-.547l1.454-2.223C1.81 12.99 2 12.354 2 11.99V9c0-3.004 2.129-5.685 5.001-6.696C7.032.968 7.645 0 9 0s1.968.968 1.999 2.305zm3.71 12.078c-.41-.627-.709-1.635-.709-2.392V9c0-2.293-1.848-4.409-4.231-4.975A1 1 0 0 1 9 3.052a1 1 0 0 1-.77.973C5.844 4.59 4 6.703 4 9v2.99c0 .752-.301 1.769-.71 2.393L2.233 16h13.534l-1.057-1.617zM9 3.052v-.64c0-.216.003-.319.004-.368-.007.05-.004.152-.004.368v.64z"}}),_c('path',{attrs:{"fill-rule":"nonzero","d":"M3 14a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2H3z"}}),_c('path',{attrs:{"d":"M9 20a2 2 0 0 0 2-2H7a2 2 0 0 0 2 2z"}})])])
          )
        }
      }
    